"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInnerHtml = exports.filterXSS = void 0;
const filter_xss_1 = require("@ies/filter-xss");
const filterXSS = (html) => (0, filter_xss_1._filterXSS)(html);
exports.filterXSS = filterXSS;
const buildInnerHtml = (html) => {
    return {
        __html: (0, exports.filterXSS)(html),
    };
};
exports.buildInnerHtml = buildInnerHtml;
